module.exports = __webpack_public_path__ + "img/icon-error.8ff1b28b.svg";